/**
 * Get the image file's width and height
 * @module utils/get-image-size
 * @param {File} file - image file
 * @return {Promise} Promise.resolve({ width, height })
 */
export default (file: File) => {
  return new Promise<any>((resolve: any) => {
    const reader = new FileReader();
    reader.onload = (evt: any) => {
      const image = new Image();
      image.onload = () => {
        const width = image.width;
        const height = image.height;
        resolve({ width, height });
      };
      image.src = evt.target.result;
    };
    reader.readAsDataURL(file);
  });
};
